import { FC } from "react";
import { Colors } from "constants/constants";
import { Box } from "@material-ui/core";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement,
  LinearScale,
  PointElement,
  LineElement,
  CategoryScale,
  BarElement,
  LineController,
  BarController,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import { formatNumberType } from "utils/formatNumbers";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
  PointElement,
  LineElement,
  CategoryScale,
  BarElement,
  LineController,
  BarController,
);

interface ReturnedRabbitReportsChartProps {
  loading: boolean;
  currentData: any[];
}

export const ReturnedRabbitReportsChart: FC<ReturnedRabbitReportsChartProps> = ({
  loading,
  currentData,
}) => {
  const labels = currentData.map((el: any) => el.report__report_date).reverse();

  const dataChart = {
    labels,
    datasets: [
      {
        type: "bar" as const,
        label: "Counter",
        data: currentData.map((el: any, index) => (el.difference ? el.difference : 0)).reverse(),
        backgroundColor: Colors.PASTEL_RED,
        minBarLength: 3,
        barThickness: 15,
        borderRadius: 25,
      },
    ],
  };

  return (
    <Box
      style={{
        display: "flex",
        width: "100%",
        boxSizing: "border-box",
        position: "relative",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {!loading && (
        //@ts-ignore
        <Chart options={options} data={dataChart} />
      )}
    </Box>
  );
};

const options = {
  responsive: true,
  scale: {
    ticks: {
      precision: 0
    }
  },
  scales: {
    y: {
      title: {
        display: false,
        text: "Value",
      },
      min: 0,
      ticks: {
        callback: function (value: number) {
          return value + "%";
        },
        color: `${Colors.MAIN}`,
        font: {
          weight: "700",
        },
      },
    },
    x: {
      grid: {
        display: false,
      },
      ticks: {
        color: `${Colors.MAIN}`,
        font: {
          weight: "700",
        },
      },
    },
  },
  plugins: {
    legend: {
      position: "top" as const,
      display: false,
    },
    title: {
      display: true,
      text: "Returned Rabbit from total Records",
    },
    tooltip: {
      callbacks: {
        label: (context: any) => {
          let label = "";
          if (context.parsed.y) {
            label = formatNumberType(context.parsed.y) + "%";
          }
          return label;
        },
      },
    },
  },
};
